import { render, staticRenderFns } from "./CapacitanceItems.vue?vue&type=template&id=2805aaa6&scoped=true&"
import script from "./CapacitanceItems.vue?vue&type=script&lang=js&"
export * from "./CapacitanceItems.vue?vue&type=script&lang=js&"
import style0 from "./CapacitanceItems.vue?vue&type=style&index=0&id=2805aaa6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2805aaa6",
  null
  
)

export default component.exports